import apiClient from '../api/client';
import {ENDPOINTS} from '../api/endpoints';

export const realEstateService = {

    getManagementUnitsByCompany: async () => {
        const response = await apiClient.get(
            `${ENDPOINTS.REAL_ESTATE}/management-units-by-company`
        );
        return response.data;
    },

};